const styles = {
  contanierGrid: {
    marginBottom: 2,
  },
};

export default styles;
